import axios from 'axios'
import { api } from '@/global'
import { authHeader } from '@/services/auth-header'

function getByRole(role){
    return axios.get( `${api.private}permissions?role=${role}`, {
        headers: authHeader()
    })
}

function addToRole(data){
    return axios.post( `${api.private}permissions`, data, {
        headers: authHeader()
    })
}

export {
    getByRole,
    addToRole
}